export function jobSearch() {
  const resetValue = function () {
    document.querySelector(".job-search-dropdown.category input").value =
      "default";
    document.querySelector(
      ".job-search-dropdown.category .value span"
    ).innerHTML = document.querySelector(
      ".job-search-dropdown.category ul li:first-of-type"
    ).innerHTML;
  };

  let limit_categories = (categories, search = false) => {
    // console.log(categories);
    /**
     * Let's ublock the category dropdown
     */
    document
      .querySelector(".job-search-dropdown.category")
      .classList.remove("disabled");

    /**
     * If there are no linked categories, let's disable categories dropdown
     */
    if (
      categories.length === 0 ||
      (categories.length === 1 && categories[0] === "")
    ) {
      /**
       * Reset value here to default
       */
      if (!search) {
        resetValue();
      }

      /**
       * Disable the dropdown
       */
      document
        .querySelector(".job-search-dropdown.category")
        .classList.add("disabled");

      if (!search) {
        document
          .querySelectorAll(".job-search-dropdown.category ul li")
          .forEach((li) => li.classList.remove("selected"));
      }
    } else if (categories.length === 1 && categories[0] === "all") {
      /**
       * Display all options
       */
      document
        .querySelectorAll(".job-search-dropdown.category ul li")
        .forEach((listItem) => (listItem.style.display = "list-item"));

      if (!search) {
        document
          .querySelectorAll(".job-search-dropdown.category ul li")
          .forEach((li) => li.classList.remove("selected"));
      }
    } else {
      /**
       * Reset value here to default
       */
      if (!search) {
        resetValue;
      }

      /**
       * Let's hide all categories except the ones in the array
       */
      document
        .querySelectorAll(".job-search-dropdown.category ul li")
        .forEach((listItem) => (listItem.style.display = "none"));

      /**
       * Now lets display all relevant items
       */
      categories.forEach((category) => {
        const item = document.querySelector(
          '.job-search-dropdown.category ul li[data-value="' + category + '"]'
        );
        if (!item) {
          return;
        }

        document.querySelector(
          '.job-search-dropdown.category ul li[data-value="' + category + '"]'
        ).style.display = "list-item";
      });

      if (!search) {
        document
          .querySelectorAll(".job-search-dropdown.category ul li")
          .forEach((li) => li.classList.remove("selected"));
      }
    }
  };

  /**
   * Limit categories dropdown on job search page
   */
  if (document.querySelector(".job-search-dropdown.sector ul li.selected")) {
    /**
     * Get an array of all the categories
     * @type {[]|*|string[]}
     */
    let categories = document
      .querySelector(".job-search-dropdown.sector ul li.selected")
      .dataset["categories"].split(",");

    limit_categories(categories, true);
  }

  /**
   * Multiple choice dropdown selection handler
   * @param e
   * @param dropdown
   */
  let handleMultipleDropdown = (e, dropdown, li) => {
    /**
     * Toggle the selected class
     */
    li.classList.toggle("selected");

    /**
     * Get new value
     */
    let val = e.target.dataset.value;
    let new_name = e.target.innerHTML;

    /**
     * Toggle the value from the dropdown hidden input
     */
    let value = dropdown.querySelector("input").value;
    let name = dropdown.querySelector(".value span").innerHTML;

    /**
     * Add or remove the value from the hidden input
     */

    value = value.split(".");
    if (value.includes(val)) value = value.filter((el) => el != val);
    else value.push(val);

    if (value.length > 1 && value.includes("default"))
      value = value.filter((el) => el != "default");

    if (value.length == 0) value.push("default");

    /**
     * Remove empty strings, due to the way split works on empty strings
     * @type {string[]}
     */
    value = value.filter((el) => el != "");

    /**
     * Do the same with the label
     */

    name = name.split(", ");
    if (name.includes(new_name)) name = name.filter((el) => el != new_name);
    else name.push(new_name);

    /**
     * Set the new values
     */
    dropdown.querySelector("input").value = value.join(".");
    // dropdown.querySelector('.value span').innerHTML = name.join(', ')
  };

  /**
   * Custom form select inputs handler
   */
  if (document.querySelector(".job-search-dropdown")) {
    /**
     * Do this for each custom dropdown
     */
    document.querySelectorAll(".job-search-dropdown").forEach((dropdown) => {
      /**
       * Open / close
       */
      if (!dropdown.classList.contains("dropdown-multiple")) {
        dropdown.addEventListener("click", (e) => {
          dropdown.classList.toggle("open");
        });
      } else {
        dropdown.addEventListener("click", (e) => {
          if (e.target.tagName != "LI") dropdown.classList.toggle("open");
        });
      }

      /**
       * Handle selection
       */
      dropdown.querySelectorAll("ul li").forEach((li) => {
        li.addEventListener("click", (e) => {
          //   console.log(e.target);
          /**
           * Handle selection only on single choice inputs
           */
          if (dropdown.classList.contains("dropdown-multiple")) {
            handleMultipleDropdown(e, dropdown, li);
            return;
          }

          /**
           * Get the new value
           */
          let val = e.target.dataset.value;
          let name = e.target.innerHTML;

          /**
           * Remove selected class from other li elements
           */
          dropdown
            .querySelectorAll("ul li")
            .forEach((li) => li.classList.remove("selected"));

          /**
           * Mark the li as selected
           */
          if (val != "default") li.classList.add("selected");

          /**
           * Limit categories based on data attribute
           *
           * FIXME: The active state bugs out on this for the categories dropdown , needs to be fixed
           */
          if (e.target.dataset["categories"] !== undefined) {
            /**
             * Get an array of all the categories
             * @type {[]|*|string[]}
             */
            let categories = e.target.dataset["categories"].split(",");

            console.log(2);
            limit_categories(categories);
          }

          /**
           * Save the value in input and on the display option
           */
          dropdown.querySelector("input").value = val;
          dropdown.querySelector(".value span").innerHTML = name;
        });
      });
    });

    let close_element_on_click_outside = (selector, active_class, e) => {
      /**
       * Continue only if there is an open dropdown
       */
      if (document.querySelector(selector)) {
        /**
         * Get The dropdown node
         * @type {Element}
         */
        let dropdown = document.querySelector(selector);

        /**
         * If the click was outside the dropdown node , close it
         */
        if (
          (e.clientX < dropdown.offsetLeft ||
            e.clientX > dropdown.offsetLeft + dropdown.offsetWidth) &&
          (e.clientY < dropdown.offsetTop ||
            e.clientY > dropdown.offsetTop + dropdown.offsetHeight)
        ) {
          dropdown.classList.remove(active_class);
        }
      }
    };

    /**
     * Close search dropdown on click outside of the element
     */
    document.addEventListener("click", (e) => {
      close_element_on_click_outside(".job-search-dropdown.open", "open", e);
      close_element_on_click_outside(".side-nav.open", "open", e);

      if (
        !document.querySelector(".side-nav").classList.contains("open") &&
        document.querySelector("#nav .hamburger").classList.contains("active")
      )
        document.querySelector("#nav .hamburger").classList.remove("active");
    });
  }

  /**
   * Job search form url builder
   */
  if (document.querySelector("form.job-search")) {
    document
      .querySelector("form.job-search")
      .addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();

        let url = document.querySelector('meta[name="baseurl"]').content + "/";
        let params = {
          sector: null,
          category: null,
          location: null,
          salary: null,
          query: null,
        };
        let url_params = ["sector", "category", "location", "salary", "query"];

        /**
         * For each form element
         */
        for (let i = 0; i < e.target.elements.length; i++) {
          params[e.target.elements[i].name] = e.target.elements[i].value;
        }

        /**
         * Add prefix to query param
         */
        if (params["query"].length > 0)
          params["query"] = "search:" + params["query"];

        /**
         * Join all the params into one array in the correct order for the url
         * Filter out all null elements
         *
         * @type {unknown[]}
         */
        url_params = url_params
          .map((param) => {
            if (
              params[param] &&
              params[param] !== null &&
              params[param] !== "default"
            )
              return params[param];

            /**
             * For sector return jobs
             */
            if (param == "sector") return "jobs";

            /**
             * Make sure we set location and category to "all"
             */
            if (param == "category" || param == "location") return "all";

            return null;
          })
          .filter((param) => param !== null);

        /**
         * Remove category and location if none are selected
         * and there is noe salary selected either
         */
        if (
          url_params[1] == "all" &&
          url_params[2] == "all" &&
          params["salary"] == "default"
        )
          url_params = url_params.filter((e) => e !== "all");

        /**
         * Add the params to the url
         *
         * @type {string}
         */
        url += url_params.join("/");

        /**
         * Set the new url
         */
        window.location.href = url + "/";
      });
  }

  /**
   * Mobile job search trigger
   */
  if (document.querySelector(".job-search-trigger-mobile")) {
    document
      .querySelector(".job-search-trigger-mobile")
      .addEventListener("click", (e) => {
        e.target.classList.toggle("active");
        document.querySelector("#header .job-search").classList.toggle("open");
      });
  }
}
